import {validacion} from 'lib.common';
import {cmps} from './constantes';
const fechaActual = new Date();
export const esquemaCampos = {
   [cmps.CLIENTE]: {valor: null, error: ''},
   [cmps.RAZON_SOCIAL]: {valor: '', error: ''},
   [cmps.TIPO_DOC]: {valor: '01', error: ''},
   [cmps.SERIE_DOC]: {valor: '', error: ''},
   [cmps.NRO_DOC]: {valor: '', error: ''},
   [cmps.PRODUCTO]: {valor: '', error: ''},
   [cmps.VERSION]: {valor: '', error: ''},
   [cmps.PRESENTACION]: {valor: '', error: ''},
   [cmps.MODULAR]: {valor: '', error: ''},
   [cmps.ANIO]: {valor: fechaActual.getFullYear(), error: ''},
   [cmps.FECHA_EXPIRACION]: {valor: null, error: ''},
   [cmps.FECHA_VIGENCIA_API]: {valor: null, error: ''},
   [cmps.FECHA_VIGENCIA_SOPORTE]: {valor: null, error: ''},
   [cmps.NRO_LLAVES]: {valor: 1, error: ''},
   [cmps.EMAIL_OTRO]: {valor: '', error: ''}
};

export const esquemaValidacion = {
   [cmps.CLIENTE]: {
      requerido: true
   },
   [cmps.RAZON_SOCIAL]: {
      requerido: true
   },
   [cmps.TIPO_DOC]: {
      requerido: true
   },
   [cmps.SERIE_DOC]: {
      requerido: true
   },
   [cmps.NRO_DOC]: {
      requerido: true
   },
   [cmps.PRODUCTO]: {
      requerido: true
   },
   [cmps.VERSION]: {
      requerido: true
   },
   [cmps.PRESENTACION]: {
      requerido: true
   },
   [cmps.ANIO]: {
      requerido: true,
      validador: {
         cast: valor => {
            return parseInt(valor);
         }
      }
   },
   [cmps.FECHA_EXPIRACION]: {
      requerido: false
   },
   [cmps.FECHA_VIGENCIA_API]: {
      requerido: false
   },
   [cmps.FECHA_VIGENCIA_SOPORTE]: {
      requerido: true
   },
   [cmps.EMAIL_OTRO]: {
      requerido: false,
      validador: {
         regla: validacion.esCorreoValido,
         error: 'Correo electrónico no válido.'
      }
   },
   [cmps.NRO_LLAVES]: {
      requerido: true,
      validador: {
         cast: valor => {
            return parseInt(valor);
         }
      }
   }
};
